import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { SharedDirectivesModule } from '../../shared-directives.module';
import { DateRangeInputComponent } from './components/date-range-input/date-range-input.component';
import { DateRangeSelectorComponent } from './components/date-range-selector/date-range-selector.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NzInputModule,
    NzButtonModule,
    NzToolTipModule,
    NzSelectModule,
    NzDropDownModule,
    TranslateModule,
    SharedDirectivesModule,
  ],
  declarations: [DateRangeSelectorComponent, DateRangeInputComponent],
  exports: [DateRangeSelectorComponent, DateRangeInputComponent],
})
export class DateRangeModule {}
